import { muiTheme } from 'mui-theme'

/**
 * Certain elements we want to be links, but not appear styled.
 * This is mostly useful for navigation within MUI data grid.
 * @example <Link sx={sxLinkNoStyling}/>
 */
export const sxLinkNoStyling = {
  color: 'inherit',
  textDecoration: 'none',
  '&:hover, &:focus': {
    color: 'inherit',
    textDecoration: 'none'
  }
}

/**
 * Useful for links that appear in tooltips, which usually have a dark grey background.
 * @example <Link sx={sxLinkForDarkBackground}/>
 */
export const sxLinkForDarkBackground = {
  color: 'inherit',
  textDecoration: 'underline',
  textDecorationColor: muiTheme.palette.common.white,
  '&:hover, &:focus': {
    color: muiTheme.palette.primary.light,
    textDecorationColor: muiTheme.palette.primary.light
  }
}
